import * as React from 'react';
export const sofortSvg = React.forwardRef(function sofortSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M0 16h12.986l2.667-16H2.667L0 16Zm7.497-9.893c0 .286.241.43 1.293.966 1.343.692 2.191 1.408 2.191 2.709 0 1.598-1.317 2.839-3.762 2.839-1.572 0-2.612-.537-3.333-1.062l.405-2.481c.697.656 1.876 1.3 2.89 1.3.583 0 1.026-.203 1.026-.56 0-.335-.265-.502-1.319-1.05-1.177-.609-2.167-1.301-2.167-2.625 0-1.54 1.356-2.816 3.727-2.816 1.192 0 2.484.417 3.886 1.213A5.88 5.88 0 0 0 11.17 6.6c-.992-.954-2.003-1.03-2.67-1.03-.584 0-1.002.179-1.002.537Z',
    }),
  );
});
sofortSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var sofort = {
  category: 'paymentmethod',
  colorable: true,
  name: 'sofort',
  svg: sofortSvg,
};
